const parseCurrency = (num) => {
    num = typeof num == 'string' ? parseFloat(num) : num;
    return num?.toLocaleString('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2 });
};

export default parseCurrency;